import React from 'react';
import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Slider,
  FormGroup,
  FormControlLabel,
  Switch,
  Typography,
  Divider,
} from '@mui/material';

const PackageFilters = ({ filters, onFilterChange }) => {
  // Ces données viendraient normalement de l'API
  const mockCompanies = [
    { id: 1, name: 'Voyage Al-Hidaya' },
    { id: 2, name: 'Al-Buraq Travel' },
    { id: 3, name: 'Hajj & Omra Services' },
  ];

  const mockDepartureCities = [
    { id: 'paris', name: 'Paris' },
    { id: 'lyon', name: 'Lyon' },
    { id: 'marseille', name: 'Marseille' },
    { id: 'lille', name: 'Lille' },
  ];

  const packageCategories = [
    { value: 'standard_non_shifting', label: 'Standard non shifting' },
    { value: 'standard_shifting', label: 'Standard shifting' },
    { value: 'premium_non_shifting', label: 'Premium non shifting' },
    { value: 'premium_shifting', label: 'Premium shifting' },
    { value: 'luxury_non_shifting', label: 'Luxury non shifting' },
    { value: 'luxury_shifting', label: 'Luxury shifting' },
  ];

  const hotelZones = [
    { value: 'A', label: 'Zone A' },
    { value: 'B', label: 'Zone B' },
    { value: 'C', label: 'Zone C' },
    { value: 'M', label: 'Zone M' },
  ];

  const durationOptions = [
    { value: '10-15', label: '10-15 jours' },
    { value: '16-20', label: '16-20 jours' },
    { value: '21-25', label: '21-25 jours' },
    { value: '26-30', label: '26-30 jours' },
  ];

  const handleChange = (e) => {
    onFilterChange({ [e.target.name]: e.target.value });
  };

  const handleSwitchChange = (e) => {
    onFilterChange({ [e.target.name]: e.target.checked });
  };

  const handlePriceChange = (event, newValue) => {
    onFilterChange({ minPrice: newValue[0], maxPrice: newValue[1] });
  };

  return (
    <Box>
      {/* Compagnie */}
      <FormControl fullWidth margin="normal" size="small">
        <InputLabel>Compagnie</InputLabel>
        <Select
          name="company"
          value={filters.company}
          onChange={handleChange}
          label="Compagnie"
        >
          <MenuItem value="">Toutes les compagnies</MenuItem>
          {mockCompanies.map((company) => (
            <MenuItem key={company.id} value={company.id}>
              {company.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {/* Ville de départ */}
      <FormControl fullWidth margin="normal" size="small">
        <InputLabel>Ville de départ</InputLabel>
        <Select
          name="departureCity"
          value={filters.departureCity}
          onChange={handleChange}
          label="Ville de départ"
        >
          <MenuItem value="">Toutes les villes</MenuItem>
          {mockDepartureCities.map((city) => (
            <MenuItem key={city.id} value={city.id}>
              {city.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {/* Catégorie */}
      <FormControl fullWidth margin="normal" size="small">
        <InputLabel>Gamme</InputLabel>
        <Select
          name="category"
          value={filters.category}
          onChange={handleChange}
          label="Gamme"
        >
          <MenuItem value="">Toutes les gammes</MenuItem>
          {packageCategories.map((category) => (
            <MenuItem key={category.value} value={category.value}>
              {category.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {/* Zone d'hébergement */}
      <FormControl fullWidth margin="normal" size="small">
        <InputLabel>Zone d'hébergement</InputLabel>
        <Select
          name="zone"
          value={filters.zone}
          onChange={handleChange}
          label="Zone d'hébergement"
        >
          <MenuItem value="">Toutes les zones</MenuItem>
          {hotelZones.map((zone) => (
            <MenuItem key={zone.value} value={zone.value}>
              {zone.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {/* Durée */}
      <FormControl fullWidth margin="normal" size="small">
        <InputLabel>Durée</InputLabel>
        <Select
          name="duration"
          value={filters.duration}
          onChange={handleChange}
          label="Durée"
        >
          <MenuItem value="">Toutes les durées</MenuItem>
          {durationOptions.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {/* Prix */}
      <Box sx={{ mt: 3, mb: 2 }}>
        <Typography variant="body2" gutterBottom>
          Budget (€)
        </Typography>
        <Slider
          getAriaLabel={() => 'Prix'}
          value={[filters.minPrice || 0, filters.maxPrice || 10000]}
          onChange={handlePriceChange}
          valueLabelDisplay="auto"
          min={0}
          max={10000}
          step={500}
        />
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Typography variant="caption">0 €</Typography>
          <Typography variant="caption">10 000 €</Typography>
        </Box>
      </Box>

      <Divider sx={{ my: 2 }} />

      {/* Disponibilité */}
      <FormGroup>
        <FormControlLabel
          control={
            <Switch
              checked={filters.availability}
              onChange={handleSwitchChange}
              name="availability"
            />
          }
          label="Places disponibles uniquement"
        />
      </FormGroup>
    </Box>
  );
};

export default PackageFilters;